"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Panel = _interopRequireDefault(require("../Panel"));
var _SideNavigation = _interopRequireDefault(require("../SideNavigation"));
var _AppMain = _interopRequireDefault(require("./AppMain"));
var _AppNavigation = _interopRequireDefault(require("./AppNavigation"));
var _AppNavigationBar = _interopRequireDefault(require("./AppNavigationBar"));
var _AppStatus = _interopRequireDefault(require("./AppStatus"));
var _Application = _interopRequireDefault(require("./Application"));
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _SkipLink = _interopRequireDefault(require("../SkipLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla
 * [Application Layout](https://vanillaframework.io/docs/layouts/application).
 *
 * This component combines the various sub-components that make up the
 * Application Layout to make it easier to consume. For some applications this
 * component maybe not be flexible enough, in which case you may choose to use
 * the sub-components directly. Be aware that the application layout requires a
 * specific structure and states to function correctly so there will be a
 * trade-off when using the sub-components directly.
 */
const ApplicationLayout = _ref => {
  let {
    aside,
    children,
    dark = true,
    logo,
    mainClassName,
    menuCollapsed,
    menuPinned,
    navigationBarClassName,
    navigationClassName,
    navItems,
    navLinkComponent,
    onCollapseMenu,
    onPinMenu,
    sideNavigation,
    status,
    statusClassName,
    mainId = "main-content",
    ...props
  } = _ref;
  const [internalMenuPinned, setInternalMenuPinned] = (0, _react.useState)(false);
  const [internalMenuCollapsed, setInternalMenuCollapsed] = (0, _react.useState)(true);
  const menuIsPinned = menuPinned !== null && menuPinned !== void 0 ? menuPinned : internalMenuPinned;
  const setMenuPinned = onPinMenu !== null && onPinMenu !== void 0 ? onPinMenu : setInternalMenuPinned;
  const menuIsCollapsed = menuCollapsed !== null && menuCollapsed !== void 0 ? menuCollapsed : internalMenuCollapsed;
  const setMenuCollapsed = onCollapseMenu !== null && onCollapseMenu !== void 0 ? onCollapseMenu : setInternalMenuCollapsed;
  return /*#__PURE__*/_react.default.createElement(_Application.default, props, /*#__PURE__*/_react.default.createElement(_SkipLink.default, {
    mainId: mainId
  }), (navItems || sideNavigation) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AppNavigationBar.default, {
    className: navigationBarClassName
  }, /*#__PURE__*/_react.default.createElement(_Panel.default, {
    dark: dark,
    logo: logo,
    toggle: {
      label: "Menu",
      onClick: () => setMenuCollapsed(!menuIsCollapsed)
    }
  })), /*#__PURE__*/_react.default.createElement(_AppNavigation.default, {
    className: navigationClassName,
    collapsed: menuIsCollapsed,
    pinned: menuIsPinned
  }, /*#__PURE__*/_react.default.createElement(_Panel.default, {
    dark: dark,
    controls: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      hasIcon: true,
      appearance: "base",
      className: (0, _classnames.default)("u-no-margin u-hide--medium", {
        "is-dark": dark
      }),
      onClick: evt => {
        setMenuCollapsed(true);
        // The menu stays open while its content has focus, so the
        // close button must blur to actually close the menu.
        evt.currentTarget.blur();
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "close",
      className: (0, _classnames.default)({
        "is-light": dark
      })
    }, "Close menu")), /*#__PURE__*/_react.default.createElement(_Button.default, {
      hasIcon: true,
      appearance: "base",
      className: (0, _classnames.default)("u-no-margin u-hide--small", {
        "is-dark": dark
      }),
      onClick: () => {
        setMenuPinned(!menuIsPinned);
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: menuIsPinned ? "close" : "pin",
      className: (0, _classnames.default)({
        "is-light": dark
      })
    }, menuIsPinned ? "Unpin menu" : "Pin menu"))),
    controlsClassName: "u-hide--large",
    stickyHeader: true,
    logo: logo
  }, navItems ? /*#__PURE__*/_react.default.createElement(_SideNavigation.default, {
    dark: dark,
    items: navItems,
    linkComponent: navLinkComponent
  }) : sideNavigation))), /*#__PURE__*/_react.default.createElement(_AppMain.default, {
    id: mainId,
    className: mainClassName
  }, children), aside, status && /*#__PURE__*/_react.default.createElement(_AppStatus.default, {
    className: statusClassName
  }, status));
};
var _default = exports.default = ApplicationLayout;